import * as Contants from './constants';
import * as API from './api';


export function authUser(login, password) {
    return {
        type: "PROMISE",
        actions: [
            Contants.START_AUTH_USER,
            Contants.FINISH_AUTH_USER,
            Contants.ERROR_AUTH_USER,
        ],
        promise: API.authUser(login, password)
    };
}

export function getProfile() {
    return {
      type: "PROMISE",
      actions: [
          Contants.START_LOAD_PROFILE,
          Contants.FINISH_LOAD_PROFILE,
          Contants.ERROR_LOAD_PROFILE
      ],
      promise: API.getProfile()
    };
}

export function updateProfile(data) {
    return {
        type: "PROMISE",
        actions: [
            Contants.START_UPDATE_PROFILE,
            Contants.FINISH_UPDATE_PROFILE,
            Contants.ERROR_UPDATE_PROFILE
        ],
        promise: API.updateProfile(data)
    };
}

export function addDevice(device_id) {
    return {
        type: "PROMISE",
        actions: [
            Contants.START_ADD_DEVICE,
            Contants.FINISH_ADD_DEVICE,
            Contants.ERROR_ADD_DEVICE
        ],
        promise: API.addDevice(device_id)
    };
}

export function sendFeedback(data) {
    return  {
        type: "PROMISE",
        actions: [
            Contants.START_SEND_FEEDBACK,
            Contants.FINISH_SEND_FEEDBACK,
            Contants.ERROR_SEND_FEEDBACK
        ],
        promise: API.sendFeedback(data)
    };
}


// WEBPACK FOOTER //
// ./src/models/user/actions.js